import * as Sentry from '@sentry/browser'

export const initSentry = () => {
	Sentry.init({
		dsn: {
			protocol: location.protocol.replace(':', ''),
			publicKey: 'e4f549292bdc1a61a2fb7e6136698db2',
			host: location.host,
			path: 'senerror',
			projectId: '475',
		},

		environment: process.env.MIX_ENV,
		tracesSampleRate: 1.0,
	})

	return Sentry
}
